export const IconMessage = () => {
    return (
        <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20 1C20 0.447715 19.5523 0 19 0H1C0.447716 0 0 0.447715 0 1V1.00002V12V12C0 12.5523 0.447716 13 1 13L1.00698 13H12.5858L15.2929 15.7071C15.5789 15.9931 16.009 16.0787 16.3827 15.9239C16.7564 15.7691 17 15.4045 17 15V13H19C19.5523 13 20 12.5523 20 12V1ZM18 11V2H2L2 11H13C13.2652 11 13.5196 11.1054 13.7071 11.2929L15 12.5858V12C15 11.4477 15.4477 11 16 11H18ZM4 5.00003C4 4.44775 4.44772 4.00003 5 4.00003L15 4.00003C15.5523 4.00003 16 4.44775 16 5.00003C16 5.55232 15.5523 6.00003 15 6.00003L5 6.00003C4.44772 6.00003 4 5.55232 4 5.00003ZM5 7C4.44772 7 4 7.44772 4 8C4 8.55228 4.44772 9 5 9L11 9C11.5523 9 12 8.55229 12 8C12 7.44772 11.5523 7 11 7L5 7Z"
                fill="currentColor"
            />
        </svg>
    );
};
